export default __webpack_public_path__ + "static/media/planetm01.b9ec1afe.png";